import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { getIsSyntheticTest } from 'modules/meta/selectors';
import { getSearchProgressPercentage } from 'modules/progressBar/selectors';
import { SearchProgressPercentage } from 'modules/progressBar/types';
import OpacityAnimation from '@daedalus/atlas/helpers/OpacityAnimation';
import { HorizontalProgressBar } from '@daedalus/atlas/HorizontalProgressBar';
const _exp = /*#__PURE__*/() => OpacityAnimation;
const Wrapper = /*#__PURE__*/styled(_exp())({
  name: "Wrapper",
  class: "wvjnew3",
  propsAsIs: true
});
export const SearchProgressBar = () => {
  const percentage = useSelector(getSearchProgressPercentage);
  const isSyntheticTest = useSelector(getIsSyntheticTest);
  const [isVisible, setIsVisible] = React.useState(true);
  useEffect(() => {
    const shouldDisplay = !isSyntheticTest && percentage > 0 && percentage < SearchProgressPercentage.SearchCompleted;
    setIsVisible(shouldDisplay);
  }, [percentage, isSyntheticTest]);
  return <Wrapper delay={100} isVisible={isVisible} ignorePosition={true}>
      <HorizontalProgressBar value={percentage} colorPath="border.brand.c600" rounded={false} />
    </Wrapper>;
};

require("./SearchProgressBar.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SearchProgressBar.tsx");